// extracted by extract-css-chunks-webpack-plugin
module.exports = {"item":"item__item--TkStG"};